import type { ForecastItemDto } from "~/ui-rtk/api/forecastApi"

export type EditableKey = Exclude<keyof ForecastItemDto, "date">

export const DEFAULT_FORECAST_VALUES: Record<EditableKey, number> = {
  daily_ad_spend: 10000,
  pct_brand: 0.15,
  monetization_factor: 1.1,
  paid_monetization_factor: 1.1,
  triggered_performance_yoy: 1.1,
  organic_social_growth: 1.1,
  organic_growth: 0.5,
  ltv_expansion: 1.1,
}

export interface ColumnDef {
  key: EditableKey
  label: string
  step: number
  prefix?: string
  suffix?: string
  displayMultiplier?: number
}

export const EDITABLE_COLUMNS: ColumnDef[] = [
  {
    key: "daily_ad_spend",
    label: "Daily Ad Spend",
    step: 100,
    prefix: "$",
  },
  {
    key: "pct_brand",
    label: "% Brand",
    step: 0.01,
    suffix: "%",
    displayMultiplier: 100,
  },
  {
    key: "monetization_factor",
    label: "Monetization",
    step: 0.05,
  },
  {
    key: "paid_monetization_factor",
    label: "Paid Monetization",
    step: 0.05,
  },
  {
    key: "triggered_performance_yoy",
    label: "Triggered YoY",
    step: 0.05,
  },
  {
    key: "organic_social_growth",
    label: "Organic Social",
    step: 0.05,
  },
  {
    key: "organic_growth",
    label: "Organic Growth",
    step: 0.05,
  },
  {
    key: "ltv_expansion",
    label: "LTV Expansion",
    step: 0.05,
  },
]

export function generateDefaultForecastData(): ForecastItemDto[] {
  const now = new Date()
  const startMonth = now.getMonth() + 1
  const startYear = now.getFullYear()

  return Array.from({ length: 12 }, (_, i) => {
    const month = ((startMonth + i - 1) % 12) + 1
    const year = startYear + Math.floor((startMonth + i - 1) / 12)
    const date = `${year}-${String(month).padStart(2, "0")}-01`

    return {
      date,
      ...DEFAULT_FORECAST_VALUES,
    }
  })
}

export function toDisplayValue(value: number, col: ColumnDef): number {
  return col.displayMultiplier ? value * col.displayMultiplier : value
}

export function fromDisplayValue(displayValue: number, col: ColumnDef): number {
  return col.displayMultiplier
    ? displayValue / col.displayMultiplier
    : displayValue
}
